var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-param-form',{attrs:{"page":"grade","grade_id":_vm.$route.query.id},on:{"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }